export default "__VITE_ASSET__r9csK$97__"